import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export const GeneralInfoNav = () => {
  const { t } = useTranslation("boClients");
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<number>(Number(searchParams.get("subTab")) || 0);

  const handleUpdateTab = (index: number) => {
    setActiveTab(index);

    setSearchParams({
      tab: searchParams.get("tab") || "0",
      subTab: index.toString(),
    });
  };

  return (
    <div className="flex w-fit flex-row self-start rounded-lg bg-gray-100 p-1">
      <NavElement
        title={t("clientInformations.tabs.company")}
        index={0}
        active={activeTab === 0}
        handleActiveTab={handleUpdateTab}
      />
      <NavElement
        title={t("clientInformations.tabs.users")}
        index={1}
        active={activeTab === 1}
        handleActiveTab={handleUpdateTab}
      />
      <NavElement
        title={t("clientInformations.tabs.pickup")}
        index={2}
        active={activeTab === 2}
        handleActiveTab={handleUpdateTab}
      />
      <NavElement
        title={t("clientInformations.tabs.payment")}
        index={3}
        active={activeTab === 3}
        handleActiveTab={handleUpdateTab}
      />
    </div>
  );
};

type NavElementProps = {
  title: string;
  index: number;
  active: boolean;
  handleActiveTab: (index: number) => void;
};

const NavElement = ({ title, index, active, handleActiveTab }: NavElementProps) => {
  return (
    <button
      onClick={() => handleActiveTab(index)}
      className={`rounded-lg focus:outline-hidden ${active ? "bg-white text-gray-900" : "bg-transparent text-gray-700"} px-3 py-2 text-sm font-medium`}
    >
      {title}
    </button>
  );
};
